import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const DollarIcon = ({ size = defaultSize }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      clipRule="evenodd"
      d="M12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C16.4183 20 20 16.4183 20 12C20 7.58172 16.4183 4 12 4ZM2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12ZM12 6C12.5523 6 13 6.44772 13 7H14.5C15.3284 7 16 7.67157 16 8.5V9C16 9.55228 15.5523 10 15 10C14.4477 10 14 9.55228 14 9H10V11H14.5C15.3284 11 16 11.6716 16 12.5V15.5C16 16.3284 15.3284 17 14.5 17H13C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17H9.5C8.67157 17 8 16.3284 8 15.5V15C8 14.4477 8.44772 14 9 14C9.55228 14 10 14.4477 10 15H14V13H9.5C8.67157 13 8 12.3284 8 11.5V8.5C8 7.67157 8.67157 7 9.5 7H11C11 6.44772 11.4477 6 12 6Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

DollarIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(DollarIcon);
